import axios from 'axios';
import Form from '../models/Form';
import FormMapper from '../mappers/FormMapper';
import FormCategory from '../models/FormCategory';
import FormCategoryMapper from '../mappers/FormCategoryMapper';
import LanguageMapper from '../mappers/LanguageMapper';
import Language from '../models/Language';
import { contains } from 'jquery';

export default class FormsService {

    public async getCategories(overviewID: number, region: string): Promise<FormCategory[]> {
        let api = axios.create({
            baseURL: ''
        })
        const data : any = await api.get('/Forms/Categories?overviewPage=' + overviewID + '&personaID=' + region);
        const categories : FormCategory[] = data.data.map((category: any) => {return new FormCategoryMapper().map(category)});

        return categories;
    }

    public async getLanguages(overviewID: number): Promise<Language[]> {
        let api = axios.create({
            baseURL: ''
        })
        const data : any = await api.get('/Forms/Languages?overviewPage=' + overviewID);
        const languages : Language[] = data.data.map((language: any) => {return new LanguageMapper().map(language)});

        return languages;
    }

    public async getForms(keyword: string, overviewID: number, region: string, languages: string[], categoryIDs: string[]): Promise<Form[]> {
        let api = axios.create({
            baseURL: ''
        });

        const data : any = await api.get('/Forms/Get?keyword=' + keyword + '&overviewPage=' + overviewID + '&personaID=' + region + '&languages=' + languages.join(',') + '&categoryIDs=' + categoryIDs.join(','));
        const forms : Form[] = data.data.Forms.map((form: any) => {return new FormMapper().map(form)});

        return forms;
    }
}